module.exports = __webpack_public_path__ + "static/media/p6.ebc237f0.jpg";